import React from 'react';
import { MessageOutlined, EditFilled } from '@ant-design/icons';
import { Input } from '@components/ui/Input/Input';
import './styles/phoneinput.css';

export interface PhoneInputProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  disabled?: boolean;
  helperText?: string;
  onHelperTextClick?: () => void;
}

export const PhoneInput: React.FC<PhoneInputProps> = ({
  value,
  onChange,
  error,
  disabled = false,
  helperText = "OTP Login • No passwords",
  onHelperTextClick,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const numericValue = e.target.value.replace(/\D/g, '');
    if (numericValue.length <= 10) {
      onChange(numericValue);
    }
  };

  return (
    <div className="phone-input-wrapper">
      <Input
        label="Mobile Number"
        type="tel"
        placeholder="Enter number"
        value={value}
        onChange={handleChange}
        error={error}
        helperText={
          <div className="phone-input-helper">
            <MessageOutlined style={{ fontSize: '16px', color: '#1890ff' }} />
            <span>{helperText}</span>
          </div>
        }
        leftIcon={<span className="text-secondary font-medium">+91</span>}
        rightIcon={
          onHelperTextClick ? (
            <button
              type="button"
              className="phone-input-edit-btn"
              onClick={onHelperTextClick}
              aria-label="Edit phone number"
              title="Edit"
            >
              <EditFilled style={{ fontSize: '24px' }} />
            </button>
          ) : undefined
        }
        inputMode="numeric"
        disabled={disabled}
      />
    </div>
  );
};
